module.exports = __webpack_public_path__ + "static/media/andry.6fd59b07.jpg";